import classnames from "classnames";
import React from "react";

import { translateWithoutContext } from "@redux/modules/value/translations/translations.helpers";

import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

type TotalsRowComponentProps = {
    label: string;
    value: string;
    isTotalPrice?: boolean;
};

const TotalsRowComponent = ({
    label,
    value,
    isTotalPrice = false,
}: TotalsRowComponentProps) => (
    <Row
        data-test={`shoppingCartSummary-${label.split(".").pop()}-price`}
        noGutters={true}
        className={classnames(
            "small",
            !isTotalPrice && "font-weight-light border-bottom",
            isTotalPrice && "font-weight-bold heading-4",
        )}
    >
        <Col xs={{ size: 5, offset: 3 }} className="p-2">
            {translateWithoutContext(label)}
        </Col>
        <Col xs={4} className={"text-right py-2"}>
            {value}
        </Col>
    </Row>
);

export default TotalsRowComponent;
